module.exports = __webpack_public_path__ + "media/images/japan/arrow_1-9ae6bbfb069c8b674259fb39b722f1a9.svg";